import {
    EstimatedReviewTime,
    MaxReviewTime,
    ProgramTheme,
} from '@sheerid/jslib';


export const getEstimatedReviewTime = (programTheme: ProgramTheme): EstimatedReviewTime => {
    let ewt: EstimatedReviewTime;
    try {
        ewt = programTheme.config.estimatedReviewTime;
    } catch (e) {
        ewt = 'A_FEW_HOURS';
    }
    return ewt;
};

export const getMaxReviewTime = (programTheme: ProgramTheme): MaxReviewTime => {
    let mrt: MaxReviewTime;
    try {
        mrt = programTheme.config.maxReviewTime;
    } catch (e) {
        mrt = '2_HOURS';
    }
    return mrt;
};

